import styled from "styled-components";

export const Weather = styled.div`
  width: 300px;
  /* float: right; */
  border-radius: 6px;
  box-shadow: 10px -2px 20px 2px rgb(0 0 0 / 30%);
  color: #fff;
  background-color: #333;
  margin: 20px auto 0 auto;
  padding: 0 20px 20px 20px;
`;

export const TopBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const City = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 1;
  margin: 0;
  letter-spacing: 1px;
`;

export const WatherDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  margin: 0;
`;

export const WeatherIcon = styled.img`
  width: 100px;
`;

export const Temperature = styled.p`
  font-weight: 600;
  font-size: 70px;
  width: auto;
  letter-spacing: -5px;
  margin: 10px 0;
`;

export const Details = styled.div`
  width: 100%;
  padding-left: 20px;
`;
export const ParameterRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ParameterLabel = styled.span`
  text-align: left;
  font-weight: 400;
  font-size: 12px;
  .top {
    border-bottom: 1px solid #fff;
  }
`;

export const ParameterValue = styled.span`
  text-align: right;
  font-weight: 600;
  font-size: 12px;
`;
